import { createRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'tenant-frontend',
});
export const tenantViewRouteRef = createRouteRef({
  id: 'tenant-view',
  params: ['short_name'],
});